module.exports = __webpack_public_path__ + "static/media/phone.fd473eda.png";